module.exports = __webpack_public_path__ + "img/elm_light_ba_list.b1713b8d.jpg";